/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ActionComponentStateConfig,
  ActionComponentStateConfig$inboundSchema,
  ActionComponentStateConfig$Outbound,
  ActionComponentStateConfig$outboundSchema,
} from "./actioncomponentstateconfig.js";

/**
 * The config of the action
 */
export type ActionComponent = {
  /**
   * The name of the action component.
   */
  name: string;
  /**
   * The config of the action button state(s).
   */
  states: Array<ActionComponentStateConfig>;
};

/** @internal */
export const ActionComponent$inboundSchema: z.ZodType<
  ActionComponent,
  z.ZodTypeDef,
  unknown
> = z.object({
  name: types.string(),
  states: z.array(ActionComponentStateConfig$inboundSchema),
});
/** @internal */
export type ActionComponent$Outbound = {
  name: string;
  states: Array<ActionComponentStateConfig$Outbound>;
};

/** @internal */
export const ActionComponent$outboundSchema: z.ZodType<
  ActionComponent$Outbound,
  z.ZodTypeDef,
  ActionComponent
> = z.object({
  name: z.string(),
  states: z.array(ActionComponentStateConfig$outboundSchema),
});

export function actionComponentToJSON(
  actionComponent: ActionComponent,
): string {
  return JSON.stringify(ActionComponent$outboundSchema.parse(actionComponent));
}
export function actionComponentFromJSON(
  jsonString: string,
): SafeParseResult<ActionComponent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ActionComponent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ActionComponent' from JSON`,
  );
}
